import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Unauthorized from '../../../pages/Unauthorized/Unauthorized';
import { logToAppInsights } from '../../utils/AppInsights';
import Store from '../../../redux/Store';

class PermissionsCheck extends Component {
  render() {
    if (this.props.appliedToPage === true) {
      if (this._checkPermission()) {
        return this.props.children;
      } else {
        return <Unauthorized />;
      }
    } else {
      if (this._checkPermission() ? this.props.hasPermission : !this.props.hasPermission) {
        return this.props.children;
      } else {
        return null;
      }
    }
  }

  _checkPermission() {
    if (!this.props.permission) {
      logToAppInsights(
        'PermissionCheck',
        'Tried performing a permission check without giving an input permission.',
        'error'
      );
      return false;
    }

    if (!this.props.user) {
      logToAppInsights(
        'PermissionCheck',
        'No information about the logged in user available.',
        'error'
      );
      return false;
    }

    if (!this.props.user.Permissions) {
      logToAppInsights(
        'PermissionCheck',
        'The logged in user has no assigned permissions.',
        'error'
      );
      return false;
    }

    if (Array.isArray(this.props.permission)) {
      return this.props.permission.some((el) => this.props.user.Permissions.indexOf(el) !== -1);
    }

    return this.props.user.Permissions.indexOf(this.props.permission) !== -1;
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

PermissionsCheck.propTypes = {
  appliedToPage: PropTypes.bool,
  permission: PropTypes.any,
};

PermissionsCheck.defaultProps = {
  hasPermission: true,
};

export const hasUserPermission = (permissionList) => {
  const state = Store.getState();
  return (
    state.user &&
    state.user.Permissions.some((el) => {
      return permissionList.includes(el);
    })
  );
};

export default connect(mapStateToProps)(PermissionsCheck);
